import defaultItems from '../../../../../common/defaultItems';

export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Video With Text',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: 1,
                    columnItems: [
                        {
                            elmIdx: '',
                            type: 'VIDEO',
                            content: {
                                ...defaultItems.VIDEO.content,
                            },
                        },
                        {
                            elmIdx: '',
                            type: 'PARAGRAPH',
                            content: {
                                ...defaultItems.PARAGRAPH.content,
                                textMarkupValue:
                                    '<p><strong>Tip:</strong> Find a way to help employees relate to the content. Show them how it affects them personally. Use emotion or storytelling to give it heart and context, and you’ll have people reading in no time.</p>',
                            },
                        },
                    ],
                },
            ],
        },
    };
}
